import { Image } from '@/components/client';

interface PhotoReviewItemProps {
  onClick: () => void;
  src: string;
  alt: string;
}

export const PhotoReviewItem = ({
  onClick,
  src,
  alt,
}: PhotoReviewItemProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="aspect-square overflow-hidden rounded-small"
    >
      <Image
        width={112}
        height={112}
        src={src}
        alt={alt}
        className="object-cover"
      />
    </button>
  );
};
